function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9.9977732mm",
    height: "7.9884868mm",
    viewBox: "0 0 9.9977732 7.9884868",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-29.079353,-116.89314)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(53.560314,37.259349)",
    style: {
      strokeWidth: 2
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      stroke: "#000000",
      strokeWidth: 0.264858,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 74.246209,459.62846 -23.890375,-41.37934 47.780748,0 z",
    transform: "matrix(0,0.1662689,-0.24007608,0,85.896629,71.283198)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.06e340487baa710461484ef6142c95de.svg";
export { ForwardRef as ReactComponent };